import { Modal, Button } from "react-bootstrap";

const FullSiteTrainingConfirmation = ({ showModal, hideModal, confirmModal, id, type, message, proceedFST }) => {
  return (
    <Modal show={showModal} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Full Site Training Confirmation {proceedFST} {!proceedFST}</Modal.Title>
      </Modal.Header>
      <Modal.Body><div className="alert alert-warn">{message}</div></Modal.Body>
      <Modal.Footer>
        {!proceedFST ?
          <Button variant="secondary" onClick={hideModal}>
            OK
          </Button>
          :
          <div>
            <Button className='cancel_button' variant="secondary" onClick={hideModal}>
              Cancel
            </Button>
            <Button
              disabled={!proceedFST}
              variant="primary"
              style={{ backgroundColor: "#5A6ACF", borderColor: "#5A6ACF" }}
              onClick={() => confirmModal(type, id)}
            >
              Proceed
            </Button>
          </div>
        }
      </Modal.Footer>
    </Modal>
  )
}

export default FullSiteTrainingConfirmation;